import styled from "styled-components";

import { smallScreen } from "src/shared/constants/screenSizes";

export const PriceCell = styled.div`
  font-weight: bold;
  min-width: 90px;
`;

export const HideMobileCell = styled.td`
  display: none;

  @media screen and (min-width: ${smallScreen}px) {
    display: table-cell;
  }
`;

export const UnitCell = styled.td`
  max-width: 130px;
  @media screen and (min-width: ${smallScreen}px) {
    max-width: auto;
  }
`;

export const ShowMobile = styled.div`
  display: block;

  @media screen and (min-width: ${smallScreen}px) {
    display: none;
  }
`;
